import React, { useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//Components
import { SubWebContacts } from "@uaveiro/ui";
import { StoreContext } from "../../context/StoreContext";

const ContactsTemplate = ({ match, ...props }) => {
  const context = useContext(StoreContext);
  const {
    params: { lang }
  } = match;

  const contactsProps = {
    lang,
    activeColor: context.state.activeColor,
    ...props
  };

  return <SubWebContacts {...contactsProps} />;
};

ContactsTemplate.propTypes = {
  match: PropTypes.object
};

export default withRouter(ContactsTemplate);
